var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 24C8 22.4241 8.31039 20.8637 8.91345 19.4078C9.5165 17.9519 10.4004 16.629 11.5147 15.5147C12.629 14.4004 13.9519 13.5165 15.4078 12.9134C16.8637 12.3104 18.4241 12 20 12C21.5759 12 23.1363 12.3104 24.5922 12.9134C26.0481 13.5165 27.371 14.4004 28.4853 15.5147C29.5996 16.629 30.4835 17.9519 31.0866 19.4078C31.6896 20.8637 32 22.4241 32 24L20 24L8 24Z",
    fill: "url(#paint0_radial_1513_3850)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 24C14.5 23.2777 14.6423 22.5625 14.9187 21.8952C15.1951 21.2279 15.6002 20.6216 16.1109 20.1109C16.6216 19.6002 17.228 19.1951 17.8952 18.9187C18.5625 18.6423 19.2777 18.5 20 18.5C20.7223 18.5 21.4375 18.6423 22.1048 18.9187C22.772 19.1951 23.3784 19.6002 23.8891 20.1109C24.3998 20.6216 24.8049 21.228 25.0813 21.8952C25.3577 22.5625 25.5 23.2777 25.5 24L20 24L14.5 24Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 29C13.06 22.1 26.94 22.1 38 29",
    stroke: "url(#paint1_linear_1513_3850)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1513_3850",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 24) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD9FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFD9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1513_3850",
    x1: 2,
    y1: 26.4125,
    x2: 38,
    y2: 26.4125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F0FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E8F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F0FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a70337da57466d8ff4c0757f5c622e23.svg";
export { ForwardRef as ReactComponent };